import { addToChainAfter, ApiHandlerDiscreteParameter, HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { AddCartPromotionApiParameter } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    AddCartPromotion,
    chain,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/ApplyPromotion";
import { PromotionModel } from "@insite/client-framework/Types/ApiModels";
import { applyPromoCode } from "@WhiteCap/Common/Utillities/CustomTracking";

type Result = {
    successMessage: string;
    errorMessage: string;
    isPromotionAppliedSuccess: boolean;
};

type HandlerType = ApiHandlerDiscreteParameter<
    {
        promotionCode: string;
    } & HasOnComplete<Result>,
    AddCartPromotionApiParameter,
    PromotionModel,
    Result
>;

export const TriggerSelectPromotionEvent: HandlerType = props => {
    if(props.apiResult)
    {
        applyPromoCode({
            event: "apply_promo_code",
            promotion_id: props.apiResult.id,
            promotion_code: props.apiResult.promotionCode,
            promotion_name: props.apiResult.name,
        });
     }
    
};

addToChainAfter(chain, AddCartPromotion, TriggerSelectPromotionEvent);
